module.exports = "<upload></upload>\n<!-- <update-product-response></update-product-response> -->\n"